import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    position: "absolute",
    padding: theme.spacing(3),
    color: theme.palette.contrastText.main,
    backgroundPosition: "center center",
    backgroundSize: "cover",
    top: 0,
  },
  orderId: {
    fontSize: "28px",
    lineHeight: "40px",
  },
  logoName: {
    fontSize: "16px",
    fontWeight: 500,
  },
}));

export default useStyles;
